module.exports = __webpack_public_path__ + "static/img/lirun.df9130e3.png";